import React from 'react';
import { TextFieldProps } from '@material-ui/core/TextField';

export const ControlInput: TextFieldProps['InputProps']['inputComponent'] =
    ({ inputRef, ...remainingProps }) =>
        <div ref={inputRef} {...remainingProps as any} />;
